import React, { useRef, useEffect } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";

const testimonials = [
  {
    type: "text",
    name: "Sandeep",
    role: "Patient",
    message:
      "Dr. Puspak Samal at Ortho Spine Care is an exceptional doctor with a deep understanding of orthopedic issues. His excellent treatment and compassionate care have made a significant impact on my recovery.",
  },
  {
    type: "text",
    name: "Sasmita",
    role: "Patient",
    message:
      "I had a great experience with Dr. Puspak Samal. Booking was easy, service was quick, and the supervision was good. The care provided was gentle and the prices were reasonable.",
  },
  {
    type: "text",
    name: "Saswat",
    role: "Patient",
    message:
      "The clinic was clean and hygienic, and the staff were extremely supportive. The care provided was of high standard, and the clinic is well connected for easy access.",
  },
  {
    type: "text",
    name: "Sandeep",
    role: "Patient",
    message:
      "Dr. Puspak Samal at Ortho Spine Care is an exceptional doctor with a deep understanding of orthopedic issues. His excellent treatment and compassionate care have made a significant impact on my recovery.",
  },
  {
    type: "text",
    name: "Sasmita",
    role: "Patient",
    message:
      "I had a great experience with Dr. Puspak Samal. Booking was easy, service was quick, and the supervision was good. The care provided was gentle and the prices were reasonable.",
  },
  {
    type: "text",
    name: "Saswat",
    role: "Patient",
    message:
      "The clinic was clean and hygienic, and the staff were extremely supportive. The care provided was of high standard, and the clinic is well connected for easy access.",
  },
];

const videoTestimonials = [
  {
    videoUrl: "https://puspak.s3.ap-south-1.amazonaws.com/test1.mp4",
  },
  {
    videoUrl: "https://puspak.s3.ap-south-1.amazonaws.com/test2.mp4",
  },
  {
    videoUrl: "https://puspak.s3.ap-south-1.amazonaws.com/test3.mp4",
  },
  {
    videoUrl: "https://puspak.s3.ap-south-1.amazonaws.com/test1.mp4",
  },
  {
    videoUrl: "https://puspak.s3.ap-south-1.amazonaws.com/test2.mp4",
  },
  {
    videoUrl: "https://puspak.s3.ap-south-1.amazonaws.com/test3.mp4",
  },
];

const Testimonial = () => {
  const textSwiperRef = useRef(null);
  const videoSwiperRef = useRef(null);
  const videoRefs = useRef([]);
  const autoScrollTimer = useRef(null);
  const isVideoPlaying = useRef(false);

  const pauseAllVideos = () => {
    videoRefs.current.forEach((video) => {
      if (video) {
        video.pause();
        isVideoPlaying.current = false;
      }
    });
  };

  const stopAutoScroll = () => {
    if (autoScrollTimer.current) {
      clearTimeout(autoScrollTimer.current);
      autoScrollTimer.current = null;
    }
  };

  const startAutoScroll = () => {
    stopAutoScroll();
    // Random time between 20-30 seconds (20000-30000 ms)
    const randomDelay = Math.floor(Math.random() * (20000 - 15000 + 1) + 10000);

    autoScrollTimer.current = setTimeout(() => {
      // Only auto-scroll if no video is playing
      if (!isVideoPlaying.current && videoSwiperRef.current) {
        videoSwiperRef.current.slideNext();
      }
      // Restart the timer for next scroll
      startAutoScroll();
    }, randomDelay);
  };

  const handleVideoEnded = () => {
    isVideoPlaying.current = false;
    if (videoSwiperRef.current) {
      videoSwiperRef.current.slideNext();
    }
    // Restart auto-scroll timer after video ends
    startAutoScroll();
  };

  const handleVideoPlay = () => {
    isVideoPlaying.current = true;
    // Stop auto-scroll when user plays a video
    stopAutoScroll();
  };

  const handleVideoPause = () => {
    isVideoPlaying.current = false;
    // Restart auto-scroll when video is paused
    startAutoScroll();
  };

  // Set up video event listeners
  useEffect(() => {
    const videos = videoRefs.current;
    videos.forEach((video) => {
      if (video) {
        video.addEventListener("play", handleVideoPlay);
        video.addEventListener("pause", handleVideoPause);
        video.addEventListener("ended", handleVideoEnded);
      }
    });

    return () => {
      videos.forEach((video) => {
        if (video) {
          video.removeEventListener("play", handleVideoPlay);
          video.removeEventListener("pause", handleVideoPause);
          video.removeEventListener("ended", handleVideoEnded);
        }
      });
      stopAutoScroll();
    };
  }, []);

  // Start auto-scroll when swiper is initialized
  const handleSwiperInit = (swiper) => {
    videoSwiperRef.current = swiper;
    pauseAllVideos();
    startAutoScroll();
  };

  // Handle manual slide change
  const handleSlideChange = () => {
    pauseAllVideos();
    // Reset auto-scroll timer on manual slide
    if (!isVideoPlaying.current) {
      stopAutoScroll();
      startAutoScroll();
    }
  };

  return (
    <section className="testimonial-section py-5">
      <div className="container text-center">
        <span className="testimonial-badge">
          💙 Patient&apos;s Testimonials
        </span>
        <h2 className="fw-bold my-3">Patient&apos;s Feedbacks</h2>

        {/* ⭐ Row 1 - Text Auto Slider (pause on hover) */}
        <Swiper
          slidesPerView={3}
          centeredSlides={true}
          spaceBetween={30}
          loop={true}
          autoplay={{ delay: 1500, disableOnInteraction: false }}
          speed={800}
          breakpoints={{
            0: { slidesPerView: 1 },
            768: { slidesPerView: 2 },
            1024: { slidesPerView: 3 },
          }}
          modules={[Navigation, Autoplay]}
          className="mb-4"
          onSwiper={(swiper) => {
            textSwiperRef.current = swiper;
          }}
          onMouseEnter={() => {
            if (textSwiperRef.current && textSwiperRef.current.autoplay) {
              textSwiperRef.current.autoplay.stop();
            }
          }}
          onMouseLeave={() => {
            if (textSwiperRef.current && textSwiperRef.current.autoplay) {
              textSwiperRef.current.autoplay.start();
            }
          }}
        >
          {testimonials.map((item, index) => (
            <SwiperSlide key={index}>
              <div className="testimonial-wrapper">
                <div className="profile-box">
                  <div className="text d-flex flex-column align-items-center">
                    <h6>{item.name}</h6>
                    <small>{item.role}</small>
                  </div>
                </div>
                <div className="testimonial-card">
                  <p className="mb-0">{item.message}</p>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>

        {/* Video Section with Auto-Scroll */}
        <Swiper
          slidesPerView={3}
          centeredSlides={true}
          spaceBetween={30}
          loop={true}
          allowTouchMove={true}
          speed={400}
          breakpoints={{
            0: { slidesPerView: 1 },
            768: { slidesPerView: 2 },
            1024: { slidesPerView: 3 },
          }}
          modules={[]}
          onSwiper={handleSwiperInit}
          onSlideChange={handleSlideChange}
          onMouseEnter={() => {
            // Pause auto-scroll on hover
            stopAutoScroll();
          }}
          onMouseLeave={() => {
            // Resume auto-scroll only if no video is playing
            if (!isVideoPlaying.current) {
              startAutoScroll();
            }
          }}
        >
          {videoTestimonials.map((item, index) => (
            <SwiperSlide key={index}>
              <div className="video-testimonial-wrapper">
                <div className="mirror-frame-container">
                  {/* Outer mirror frame */}
                  <div className="mirror-frame-outer">
                    {/* Inner glass reflection effect */}
                    <div className="glass-reflection"></div>

                    {/* Video container with stylish border */}
                    <div className="video-card-small">
                      <video
                        ref={(el) => (videoRefs.current[index] = el)}
                        src={item.videoUrl}
                        playsInline
                        loop={false}
                        controls
                        className="video-element-small"
                      />

                      {/* Play button overlay animation */}
                      <div className="video-overlay-glow">
                        <div className="play-icon-pulse">
                          <svg
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="white"
                          >
                            <path d="M8 5v14l11-7z" />
                          </svg>
                        </div>
                      </div>
                    </div>

                    {/* Mirror shine effect */}
                    <div className="mirror-shine"></div>
                  </div>

                  {/* Bottom reflection shadow */}
                  <div className="reflection-shadow"></div>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>

      <style jsx>{`
        .testimonial-section {
          background: #f7f7f7;
          position: relative;
          overflow: hidden;
        }

        .testimonial-badge {
          display: inline-block;
          background: linear-gradient(135deg, #a5d0c5 0%, #51afc6 100%);
          color: white;
          padding: 8px 20px;
          border-radius: 50px;
          font-size: 14px;
          font-weight: 500;
        }

        /* Mirror Frame Container */
        .mirror-frame-container {
          position: relative;
          padding: 15px;
          transition: all 0.1s ease;
        }

        /* Outer Mirror Frame */
        .mirror-frame-outer {
          position: relative;
          background: linear-gradient(135deg, #e8e8e8 0%, #c0c0c0 100%);
          padding: 12px;
          border-radius: 20px;
          box-shadow:
            0 20px 40px rgba(0, 0, 0, 0.3),
            inset 0 1px 2px rgba(180, 180, 180, 0.8),
            0 0 0 1px rgba(177, 177, 177, 0.5);
          transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
        }

        .mirror-frame-outer:hover {
          transform: translateY(-8px) scale(1.02);
          box-shadow:
            0 30px 60px rgba(0, 0, 0, 0.4),
            inset 0 1px 3px rgba(255, 255, 255, 0.9),
            0 0 0 2px rgba(0, 204, 255, 0.3);
        }

        /* Glass Reflection Effect */
        .glass-reflection {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background: linear-gradient(
            135deg,
            rgba(255, 255, 255, 0.3) 0%,
            rgba(255, 255, 255, 0) 50%,
            rgba(255, 255, 255, 0.1) 100%
          );
          pointer-events: none;
          z-index: 2;
          border-radius: 12px;
        }

        @keyframes shine {
          0% {
            transform: translateX(-100%) rotate(45deg);
          }
          20%,
          100% {
            transform: translateX(100%) rotate(45deg);
          }
        }

        .video-card-small {
          position: relative;
          height: 25rem;
          width: 20rem;
          overflow: hidden;
          border-radius: 12px;
          background: #000;
          cursor: pointer;
          transition: all 0.3s ease;
        }

        .video-element-small {
          height: 100%;
          width: 100%;
          object-fit: cover;
          transition: transform 0.5s ease;
        }

        .mirror-frame-outer:hover .video-element-small {
          transform: scale(1);
        }

        /* Reflection Shadow */
        .reflection-shadow {
          position: absolute;
          bottom: -15px;
          left: 10%;
          width: 80%;
          height: 30px;
          background: radial-gradient(
            ellipse,
            rgba(0, 0, 0, 0.3) 0%,
            transparent 70%
          );
          filter: blur(8px);
          opacity: 0;
          transition: opacity 0.3s ease;
          pointer-events: none;
          z-index: 1;
        }

        .mirror-frame-container:hover .reflection-shadow {
          opacity: 1;
        }

        /* Auto-scroll animation for video cards */
        .video-testimonial-wrapper {
          animation: fadeInUp 0.6s ease-out;
        }

        @keyframes fadeInUp {
          from {
            opacity: 0;
            transform: translateY(30px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        /* Swiper slide center effect */
        .swiper-slide {
          transition: all 0.1s ease;
        }

        .swiper-slide-active .mirror-frame-outer {
          box-shadow:
            0 25px 50px rgba(0, 0, 0, 0.4),
            inset 0 1px 3px rgba(255, 255, 255, 0.9),
            0 0 0 2px rgba(0, 47, 255, 0.5);
        }

        /* Responsive adjustments */
        @media (max-width: 768px) {
          .video-card-small {
            height: 15rem;
            width: 100%;
          }

          .play-icon-pulse {
            width: 45px;
            height: 45px;
          }

          .play-icon-pulse svg {
            width: 18px;
            height: 18px;
          }
        }

        /* Smooth scrolling for swiper */
        .swiper-wrapper {
          transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
        }

        /* Custom video controls styling */
        video::-webkit-media-controls {
          border-radius: 8px;
        }

        video::-webkit-media-controls-play-button {
          border-radius: 50%;
        }

        /* Existing testimonial styles - keeping intact */
        .testimonial-wrapper {
          background: white;
          border-radius: 15px;
          padding: 20px;
          box-shadow: 0 5px 20px rgba(0, 0, 0, 0.1);
          transition: transform 0.1s ease;
        }

        .testimonial-wrapper:hover {
          transform: translateY(-5px);
        }

        .profile-box {
          margin-bottom: 15px;
        }

        .testimonial-card {
          text-align: center;
        }

        .testimonial-card p {
          color: #666;
          line-height: 1.6;
        }
      `}</style>
    </section>
  );
};

export default Testimonial;
